import React from 'react';

export default {
  title: 'Select a security type to continue',
  personalGuarantors: {
    title: 'Personal Guarantors',
    description:
      'To continue, please provide the full name as it appears on their ID and personal email address for the following guarantors. Please note, any discrepancies may delay your client’s access to funds.',
    label: {
      fullName: 'Confirmed full name',
      email: 'Email address'
    },
    modal: {
      heading: 'Confirm details for {{name}}',
      nameDescription:
        'Please confirm the guarantor’s full name as it appears on their ID',
      emailDescription: 'Please confirm the guarantor’s personal email address',
      label: {
        firstName: 'First name',
        middleNames: 'Middle names (optional)',
        lastName: 'Last name',
        emailAddress: 'Email address',
        updateDetails: 'Update details'
      }
    }
  },
  debenture: {
    title: 'Debenture',
    subtitle: 'Your business is eligible for a Debenture.',
    description:
      'If your client does not want to sign a Personal Guarantee, we can secure the loan against the business. Please note that Debenture backed loans will have a 2-5% higher interest rate.',
    footer: () => (
      <>
        Please get in touch with your Business Development Executive to talk
        through this option.
      </>
    )
  },
  radio: {
    legend: 'How would your client like to proceed?',
    debenture: () => <>Debenture</>,
    personalGuarantee: () => <>Personal Guarantee</>
  },
  debentureOffer: {
    title: "Your client's offer requires a debenture against the business",
    paragraph:
      'We will send your client a document to be signed by a company director.'
  },
  personalGuaranteeCard: {
    title: 'Personal Guarantee'
  }
};
